import { HouseholdLayout } from '@/components/layouts/HouseholdLayout';
import { PageHeader } from '@/components/PageHeader';
import { Outlet } from 'react-router-dom';
import { TabsSegmented } from '@/components/TabsSegmented';
import { useLocation, useNavigate } from 'react-router-dom';
import { Stack } from '@mui/joy';

const TAB_PATHS = ['personal', 'household', 'emojis', 'tags', 'events'];
const TAB_LABELS = ['Personal', 'Household', 'Emojis', 'Tags', 'Events'];

export function SettingsPage() {
  const location = useLocation();
  const currentPath = location.pathname.split('/').pop();
  const activeTab = TAB_PATHS.indexOf(currentPath);
  const navigate = useNavigate();

  function setActiveTab(tab) {
    navigate(`./${TAB_PATHS[tab]}`);
  }

  return (
    <HouseholdLayout>
      <Stack direction="column" gap={2}>
        <PageHeader title="Settings" subtitle="Manage your account and household settings" />
        <TabsSegmented tabs={TAB_LABELS} activeTab={activeTab} setActiveTab={setActiveTab} />
      </Stack>
      <Outlet />
    </HouseholdLayout>
  );
}
